import React from "react";
import PropTypes from "prop-types";
import { Text, StyledButton } from "./style";
import RippleButton from "../RippleButton";

// Button for the header
const ImageButton = (props) => {
    return (
        <RippleButton component={StyledButton} {...props}>
            <img src={props.image} style={{ height: 40 }} />
            <Text>{props.children}</Text>
        </RippleButton>
    );
};

ImageButton.propTypes = {
    image: PropTypes.any,
    children: PropTypes.any,
    onClick: PropTypes.func,
};

export default ImageButton;
